export const SHOPPING_BAG_ICON_ROOT = 'shopping-bag-icon-root';
export const SHOPPING_BAG_COUNTER_ROOT = 'shopping-bag-counter-root';
